import { render, staticRenderFns } from "./AccordionControl.vue?vue&type=template&id=24f135d0&scoped=true&"
import script from "./AccordionControl.vue?vue&type=script&lang=js&"
export * from "./AccordionControl.vue?vue&type=script&lang=js&"
import style0 from "./AccordionControl.vue?vue&type=style&index=0&id=24f135d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f135d0",
  null
  
)

export default component.exports